import * as actionTypes from './types/subscriptionActionTypes';

export function availableApplicationsFetched(applications) {
    return {
        type: actionTypes.FETCH_AVAILABLE_APPLICATIONS_SUCCEED,
        availableApplications: applications,
    };
}
